import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Unavailability } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeUnavailability(
    request: Boundaries["removeUnavailability"]["request"],
  ): void;
}

function useRemoveUnavailability(
  unavailability: Identifiable<Unavailability>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveUnavailabilityRequestPending(unavailability),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveUnavailabilityRequestSuccess(unavailability),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveUnavailabilityRequestFailure(unavailability),
    ),
    removeUnavailability: core.removeUnavailability,
  };
}

export { useRemoveUnavailability };
